export default __webpack_public_path__ + "static/media/Kwiat-Cover.38609a45.png";